<template>
  <Page class="queryView">
    <div class="queryView-main">
      <div style="text-align: right">
        <a-button class="app-btn" type="default" @click="handleAdd">添加导游</a-button>
      </div>

      <a-table
        class="mt-5"
        :row-key="
          (record, index) => {
            return index
          }
        "
        bordered
        :loading="tableLoading"
        :columns="tableColumns"
        :dataSource="dataSource"
        @change="handleTableChange$qv"
        :scroll="{ x: 1400 }"
        :pagination="{
          current: pageNumber,
          pageSize: limit,
          total: countTotal,
          showSizeChanger: true,
          showQuickJumper: true,
        }"
      />
    </div>
    <a-modal :visible="addGuideType" :title="modalTitle" @ok="submit" @cancel="handleCancel">
      <div>
        <a-form :form="form">
          <a-form-item label="导游姓名">
            <a-input v-decorator="['touristGuideName', { rules: [{ required: true, message: '请输入导游姓名' }] }]" />
          </a-form-item>
          <a-form-item label="手机号">
            <a-input v-decorator="['contactPhone', { rules: [{ required: true, message: '请输入手机号' }] }]" />
          </a-form-item>
          <a-form-item label="体验密码">
            <a-input v-decorator="['miniPassword']" />
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
    <a-modal :visible="codeUrlType" title="绑定微信" @cancel="handleCancel(1)">
      <div
        v-if="codeUrl"
        style="width: 100%;display:flex;justify-content: center;align-items: center;flex-direction: column;"
      >
        <img :src="codeUrl" style="width:200px;height:200px" alt="" />
      </div>
    </a-modal>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'

export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '10%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span>{this.limit * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '导游名称',
        align: 'center',
        dataIndex: 'touristGuideName',
      },
      {
        title: '联系电话',
        align: 'center',
        dataIndex: 'contactPhone',
      },
      {
        title: '绑定微信',
        align: 'center',
        dataIndex: 'userId',
        customRender: (text, row) => {
          return (
            <a
              onClick={() => {
                this.bindCode(row)
              }}
            >
              {text ? '已绑定' : '去绑定'}
            </a>
          )
        },
      },
      {
        title: '操作',
        width: '12%',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex justify-center gap-5 text-primary-500">
              <a
                class="text-primary-500"
                onClick={() => {
                  this.checkRow(row, 'edit')
                }}
              >
                修改
              </a>
              <a
                onClick={() => {
                  this.handleDel(row)
                }}
              >
                删除
              </a>
            </div>
          )
        },
      },
    ]
    return {
      modalTitle: '添加导游',
      // labelCol: { style: { width: '100px' } },
      pageNumber: 1,
      limit: 10,
      countTotal: 0,
      codeUrlType: false,
      tableLoading: false,
      addGuideType: false,
      codeUrl: '',
      tableColumns: tableColumns,
      dataSource: [],
      form: this.$form.createForm(this),
      typeList: [
        { label: 'API', value: 1 },
        { label: 'H5', value: 2 },
        { label: '小程序', value: 3 },
      ],
    }
  },
  components: {
    Page,
  },
  async mounted() {
    this.doQuery()
  },
  methods: {
    async bindCode(row) {
      if (!row.userId) {
        const res = await this.$axios.post(`/guide/admin/guide/generateCodeTouristGuide/${row.id}`)
        if (res.success) {
          this.codeUrl = res.data
        }
        this.codeUrlType = true
      } else {
        this.$confirm({
          title: '解除绑定确认',
          content: '您确认解除绑定导游?',
          onOk: async () => {
            const res = await this.$axios.delete(`/guide/admin/guide/unBindTouristGuide/${row.id}`)
            if (res.success) {
              this.$message.success('解除绑定成功')
              this.doQuery()
            }
          },
          onCancel: () => {
            // reject(new Error('E_CANCEL'))
          },
        })
      }
    },
    submit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const params = values
          let res = null
          if (this.modalTitle == '添加导游') {
            res = await this.$axios.post('/guide/admin/guide/add', params)
          } else {
            res = await this.$axios.put('/guide/admin/guide/edit', params)
          }
          console.info('success', res)
          if (res && res.success) {
            this.addGuideType = false
            this.doQuery()
          }
        }
      })
    },
    handleCancel(e) {
      this.addGuideType = false
      this.codeUrlType = false
      if (e) {
        this.doQuery()
      }
    },
    async doQuery(_page = this.pageNumber, _limit = this.limit) {
      this.tableLoading = true
      const res = await this.$axios.get('/guide/admin/guide/getList', {
        params: {
          page: _page,
          limit: _limit,
        },
      })
      this.countTotal = Number(res.count)
      this.dataSource = res.data
      this.tableLoading = false
    },
    async handleAdd() {
      this.modalTitle = '添加导游'
      this.form.resetFields()
      this.addGuideType = true
    },
    async checkRow(row) {
      this.modalTitle = '编辑导游'
      const res = await this.$axios.get(`/guide/admin/guide/get/${row.id}`)
      this.$nextTick(() => {
        this.safeSetFieldsValue$t(this.form, res.data)
      })
      this.addGuideType = true
    },
    async handleDel(row) {
      this.$confirm({
        title: '删除确认',
        content: '您确认删除当前导游?',
        onOk: async () => {
          const res = await this.$axios.delete(`/guide/admin/guide/delete/${row.id}`)
          if (res.success) {
            this.$message.success('删除成功')
            this.doQuery()
          }
        },
        onCancel: () => {
          // reject(new Error('E_CANCEL'))
        },
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
